import React, { useEffect, useState, FC } from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./ModalBanner.css";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from "axios";

interface ModalBannerProps {
  onClose: () => void;
  setShowModal: (show: boolean) => void;
}

interface PromotionData {
  title: string;
  image: string;
  url: string;
  endDate: string;
}

const ModalBanner: FC<ModalBannerProps> = ({ onClose, setShowModal }) => {
  const [promotionsData, setPromotionsData] = useState<PromotionData[]>([]);
  const [width, setWidth] = useState<number>(window.innerWidth);

  const isDesktop = width > 500;

  useEffect(() => {
    const getPromotions = async () => {
      try {
        const response = await axios.get<{ data: PromotionData[] }>(
          "https://demos.inter.mx/v1/catalogs/promo-banner",
          { params: { tag: "coche" } }
        );

        const data = response?.data?.data?.filter(item => item.title.includes("Banner")) ?? [];
        
        if (data.length > 0) {
          /**
           * Filtro de fecha de vencimiento
           */
          let current: PromotionData[] = [];
          data.map((item) => {
            // Promocion en curso
            if (new Date(item.endDate) > new Date()) {
              current.push(item);
            }
          });

          if (current.length > 0) {
            setPromotionsData(current);
          } else {
            setShowModal(false);
          }
        } else {
          setShowModal(false);
        }
      } catch (error) {
        console.error("Error al hacer la solicitud:", error);
        setShowModal(false);
      }
    };

    getPromotions();

    window.scrollTo(0, 0);

    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2500,
    autoplaySpeed: 3500,
    arrows: true,
  };

  const handleImageClick = (type: string) => {
    switch (type) {
      case 'coche':
        window.open('https://cocheseguro.inter.mx/inicio', '_blank');
        break;
      case 'gmm':
        window.open('https://medicoseguro.inter.mx/inicio', '_blank');
        break;
      case 'tr1s':
        window.open('https://teregalamosunseguro.inter.mx/', '_blank');
        break;
      default:
        break;
    }
  };

  const handleCloseClick = () => {
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-button-close mb-2">
          <IconButton
            type="button"
            sx={{ p: "12px", color: "#212121" }}
            aria-label="closeModal"
            onClick={handleCloseClick}
          >
            <CloseIcon sx={{ fontSize: "32px" }} />
          </IconButton>
        </div>
        <div className="carousel-container">
          <Slider {...settings}>
            {promotionsData.map((data, index) => (
              <img
                src={isDesktop ? data.image : data.url}
                alt={`Anuncio ${index}`}
                className="carousel-image"
                key={index}
              />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ModalBanner;
